import { render, staticRenderFns } from "./BindsClearIcon.vue?vue&type=template&id=45489045&"
import script from "./BindsClearIcon.vue?vue&type=script&lang=js&"
export * from "./BindsClearIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports